import React from 'react'
import { Dropdown } from 'react-bootstrap'
import debounce from 'lodash/debounce'
import { FaChevronDown as DownArrow } from 'react-icons/fa'
import './styles.scss'

class ShippingMethodDropdown extends React.Component {
  constructor(props) {
    super(props)
    const standardItem = {
      name: 'Select Shipping Method',
      shippingMethodId: '',
    }
    this.state = {
      selectedValue: '',
      selectedLabel: standardItem ? standardItem.name : '',
    }
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(
        prevProps?.shippingMethodList?.shippingDetails?.cartShippingMethods
      ) !==
      JSON.stringify(
        this.props?.shippingMethodList?.shippingDetails?.cartShippingMethods
      )
    ) {
      this.setState({
        selectedValue: '',
        selectedLabel: 'Select Shipping Method',
      })
    }
  }

  render() {
    const {
      title,
      disableTabIndex = 0,
      shippingMethodList,
      handleShippingMethodChange,
    } = this.props
    const items = shippingMethodList?.shippingDetails?.cartShippingMethods.map(
      item => {
        const isSelectedClass =
          item.shippingMethodId === this.state.selectedValue ? 'selected' : ''
        return (
          <Dropdown.Item
            as="button"
            key={item.shippingMethodId}
            value={item.shippingMethodId}
            className={isSelectedClass}
            onClick={debounce(event => {
              handleShippingMethodChange(item)
              this.setState({
                selectedValue: item.shippingMethodId,
                selectedLabel: item.name,
              })
            }, 700)}
            onKeyPress={debounce(event => {
              this.setState({
                selectedValue: item.shippingMethodId,
                selectedLabel: item.name,
              })
            }, 700)}
            data-testid="qa-subscription-label">
            {item.name}
          </Dropdown.Item>
        )
      }
    )
    return (
      <Dropdown
        className="subscription-dropdown-nuskin"
        data-testid="frequency-dropdown">
        <Dropdown.Toggle
          className="d-flex subscription-dropdown-toggle"
          tabIndex={disableTabIndex}>
          <div className="dropdown-left-section">
            <span className="dropdown-nuskin-title">{title}</span>
            <span
              className="dropdown-nuskin-value mt-1 shipping-method-value"
              data-testid="frequency-value">
              {this.state.selectedLabel}
            </span>
          </div>
          <div className="dropdown-right-section">
            <DownArrow name="arrows" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="subscription-dropdownmenu z-1">
          {items}
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}
export default ShippingMethodDropdown
export { ShippingMethodDropdown }
